import { SocialType } from 'constant/socialAuth';

/** 绑定信息（用户名、头像等） */
export interface Profile {
    name?: string;
    avatar?: string;
    bindAddress?: string;
}

/** 社交媒体信息（媒体类型、名称、图标等）*/
export interface Social {
    type: SocialType;
    label: string;
    Icon: any;
    disabled?: boolean; // 是否开放使用
}

export const socials: any = {
    [SocialType.Twitter]: {
        type: SocialType.Twitter,
        label: 'X',
    },
    // [SocialType.Telegram]: {
    //     type: SocialType.Telegram,
    //     label: 'Telegram',
    //     disabled: true,
    // },
    [SocialType.Discord]: {
        type: SocialType.Discord,
        label: 'Discord',
    },
};
